export type StorageKey = 'accessToken' | 'branch' | 'company' | 'firebaseUser' | 'tenant' | 'tenants' | 'user' | 'redirectUrl' | 'uomMasterList' | 'currencyMasterList' | 'countryMasterList';

export const StorageKey = {
    accessToken: 'accessToken' as StorageKey,
    branch: 'branch' as StorageKey,
    company: 'company' as StorageKey,
    firebaseUser: 'firebaseUser' as StorageKey,
    tenant: 'tenant' as StorageKey,
    tenants: 'tenants' as StorageKey,
    user: 'user' as StorageKey,
    redirectUrl: 'redirectUrl' as StorageKey,
    uomMasterList: 'uomMasterList' as StorageKey,
    currencyMasterList: 'currencyMasterList' as StorageKey,
    countryMasterList: 'countryMasterList' as StorageKey,
} as const satisfies Record<StorageKey, StorageKey>;